<div class="order-info">
  <div class="info">
    <div class="info-row">
      <div class="name">{{'payment-form.order.price' | customLocale}}:</div>
      <div class="value">{{order.amount}} {{order.currencyCode}}</div>
    </div>
    <div class="info-row" *ngIf="order.taxAmount">
      <div class="name">{{'payment-form.order.processing_fee' | customLocale}}:</div>
      <div class="value">{{order.taxAmount}} {{order.currencyCode}}</div>
    </div>
  </div>

  <div class="total">
    <div class="name">{{'payment-form.order.total' | customLocale}}:</div>
    <div class="value">{{order.amountToPay}} {{order.currencyCode}}</div>
  </div>
  <div class="approximate" *ngIf="order.approximateAmountToPay">
    {{'payment-form.order.approximate' | customLocale}} {{order.approximateCurrencyCode}}: {{order.approximateAmountToPay}}
  </div>
</div>

<div class="additional-info" *ngIf="order.approximateAmountToPay">
  <ul>
    <li>{{'payment-form.order.additional_text1' | customLocale}}</li>
    <li>{{'payment-form.order.additional_text2' | customLocale}} {{order.currencyCode}}.</li>
  </ul>
</div>
